<mat-toolbar class="flex justify-between !h-24">
    <h1>PlayCharge.Backoffice</h1>
    <div class="flex items-center gap-6">
    <img
            class="size-24"
            [src]="env.icon"
            alt="" />
    <span class="text-5xl" [ngClass]="{ 'text-red-500': env.name === 'PRODUCTION', 'text-green-400': env.name === 'STAGE' }"  >{{ env.name }} {{ env.appName }}</span>
    </div>
    <span>Refresh rate: {{ serverConfigsStore.config()?.cacheUpdateTimeout }} sec</span>
</mat-toolbar>
